import { Pipe, PipeTransform } from '@angular/core';
import { TabloGroupConfig } from '@ui/tablo-generator/types';

@Pipe({
    name: 'getConfigFromMainOrFromChild',
    standalone: false
})
export class GetConfigFromMainOrFromChildPipe implements PipeTransform {
  transform<P extends keyof TabloGroupConfig>(
    value: TabloGroupConfig,
    configIndex: P,
    index: number,
  ): TabloGroupConfig[P] | null {
    if (
      typeof value.singleChildConfig !== 'undefined' &&
      typeof value.singleChildConfig[index] !== 'undefined' &&
      typeof value.singleChildConfig[index][configIndex as string] !==
        'undefined'
    ) {
      return value.singleChildConfig[index][configIndex as string];
    }
    return value[configIndex];
  }
}
